import {Component, OnInit} from '@angular/core';
import {BankTransferLoadService} from '../../../bank-transfer-load.service';
import {DatePipe, Location} from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {GpsLoadResponseFileImportResult} from '../../../dto/gps-load-response-file-import-result';

@Component({
  selector: 'app-gps-load-response-upload',
  templateUrl: './gps-load-response-upload.component.html',
  styleUrls: ['./gps-load-response-upload.component.css']
})
export class GpsLoadResponseUploadComponent implements OnInit {

  isLoading: boolean;
  isImporting: boolean;
  csvLines: GpsLoadResponseFileImportResult[];

  constructor(
    private bankTransferLoadService: BankTransferLoadService,
    private location: Location,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {


  }




  onUpload(file: any) {
    this.isLoading = true;
    this.isImporting = true;
    this.bankTransferLoadService.uploadGpsResponseImportCsv(file)
      .subscribe(
        result => {

          this.csvLines = result;
          this.isImporting = false;
          this.isLoading = false;

        },
        err => {
          this.snackBar.open(err.error.message || err.error || err.message || err, null, {
            duration: 5000,
            panelClass: ['app-mat-snack-bar']
          });
          this.isLoading = false;
          this.isImporting = false;


        }
      );
  }

  returnBack() {
    this.location.back();
  }




}
